import axios from 'axios'
import Cookies from 'js-cookie'

const API_URL = process.env.REACT_APP_BACKEND_URL

export const getAllNews = async ({ currentPage, search }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/news-id`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      params: {
        pagination: {
          pageSize: 10,
          page: currentPage,
        },
        filters: {
          title: {
            $containsi: search,
          },
        },
      },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching news data:', error)
    throw error
  }
}

export const getDetailNews = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.get(`${API_URL}/api/news-id/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return response.data
  } catch (error) {
    console.error('Error fetching news data:', error)
    throw error
  }
}

export const deleteNews = async ({ id }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.delete(`${API_URL}/api/news-id/${id}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting news data:', error)
    throw error
  }
}

export const createNews = async ({ form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.post(`${API_URL}/api/news-id`, form, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting news data:', error)
    throw error
  }
}

export const updateNews = async ({ id, form }) => {
  try {
    const accessToken = Cookies.get('access_token')
    const response = await axios.put(`${API_URL}/api/news-id/${id}`, form, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error deleting news data:', error)
    throw error
  }
}
